<ion-content class="callback-shell">
  <div class="wrapper">
    <div class="header-row">
      <div class="eyebrow">Tubify</div>
      <div class="pill">OAuth return</div>
    </div>

    <div class="card glass-card">
      <div class="icon-wrap" [class.success]="success" [class.error]="error">
        <ion-spinner *ngIf="loading" name="crescent"></ion-spinner>
        <ion-icon *ngIf="success" name="checkmark-circle"></ion-icon>
        <ion-icon *ngIf="error && !loading" name="alert-circle"></ion-icon>
      </div>

      <h1 *ngIf="loading">Finalizing your {{ provider }} connection…</h1>
      <h1 *ngIf="success">Linked successfully</h1>
      <h1 *ngIf="error && !loading">We hit a snag</h1>

      <p *ngIf="loading">Hold on while we refresh your account.</p>
      <p *ngIf="success">Your {{ provider }} account is linked. Redirecting to Account…</p>
      <p *ngIf="error && !loading">{{ error }}</p>

      <div class="actions" *ngIf="!loading">
        <button *ngIf="success" class="futuristic-button" type="button" (click)="goToAccount()">Go to Account</button>
        <button *ngIf="error" class="secondary-futuristic" type="button" (click)="goToAccount()">Back to Account</button>
      </div>
    </div>
  </div>
</ion-content>
